import routeRestrictions from 'new/constants/routeRestrictions.json';
import { getFeatureFlagValue } from 'new/constants/featureFlags';

const isValid = (i) => i != null;

const filter = ({
  restrictedTiers = [],
  hasExpressTierLimitedAccess,
  hasSelfSignupTierLimitedAccess,
}) => {
  if (hasExpressTierLimitedAccess && restrictedTiers?.includes('express_tiers')) {
    return false;
  }

  if (hasSelfSignupTierLimitedAccess && restrictedTiers?.includes('self_signup_tiers')) {
    return false;
  }

  return true;
};

export const filterMainNavigationItemsByTier = (
  data: any,
  hasExpressTierLimitedAccess: boolean,
  hasSelfSignupTierLimitedAccess: boolean,
) => {
  return data.filter(isValid).filter((item) => {
    const { restrictedTiers = [] } = item ?? {};
    return filter({
      restrictedTiers,
      hasExpressTierLimitedAccess,
      hasSelfSignupTierLimitedAccess,
    });
  });
};

export const filterNavigationContentByTier = (
  content: any[],
  hasExpressTierLimitedAccess: boolean,
  hasSelfSignupTierLimitedAccess: boolean,
) => {
  return content
    .filter(isValid)
    .filter((section) => {
      const { restrictedTiers = [] } = section ?? {};
      return filter({
        restrictedTiers,
        hasExpressTierLimitedAccess,
        hasSelfSignupTierLimitedAccess,
      });
    })
    .filter(isValid)
    .map((section) => {
      const { items, ...rest } = section;

      const filteredItems = items?.filter(isValid)?.filter((item: any) => {
        const { restrictedTiers = [] } = item ?? {};
        return filter({
          restrictedTiers,
          hasExpressTierLimitedAccess,
          hasSelfSignupTierLimitedAccess,
        });
      });

      return { ...rest, items: filteredItems };
    });
};

/**
 * Keeps section structure but drops nav items whose `featureFlagKey` resolves false via GrowthBook.
 * Sections with no remaining items are omitted (empty headings avoided).
 */
export const filterNavigationContentByFeatureFlags = (content: any[]) => {
  return content
    .filter(isValid)
    .map((section) => {
      const { items = [], ...rest } = section ?? {};
      const filteredItems = items.filter(isValid).filter((item: any) => {
        if (!item?.featureFlagKey) return true;
        return Boolean(getFeatureFlagValue(item.featureFlagKey));
      });
      return { ...rest, items: filteredItems };
    })
    .filter(isValid)
    .filter((section) => (section.items?.length ?? 0) > 0);
};

export const getAllRestrictedPathsByTier = (tierName: string) => {
  return routeRestrictions[tierName as keyof typeof routeRestrictions] ?? [];
};

export const isPathRestrictedByTier = (path: string, tierName: string) => {
  const allRestrictedPaths = getAllRestrictedPathsByTier(tierName);
  return allRestrictedPaths.includes(path);
};
